import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  Image,
  Button,
} from "@chakra-ui/react";
import CloseIconBlack from "../../../assets/images/booking/x-circle.svg";
import { InputControl } from "../../../components/form/formControls";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { formatPriceUS } from "../../../utils/utils";
const schema = Yup.object().shape({
  disbursedAmount: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      if (typeof originalValue === "string") {
        return originalValue.trim() === "" ? null : Number(originalValue);
      }
      return originalValue === null ? null : Number(originalValue);
    })
    .moreThan(0, "Số tiền thanh toán phải lớn hơn 0")
    .required("Số tiền thanh toán là bắt buộc"),
});

const AddBrokerDebtDisbursement = ({
  isOpen,
  onClose,
  defaultValues,
  isEdit,
  onSubmit,
  id,
}) => { 
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: defaultValues || {},
  });

  useEffect(() => {
    if (isOpen) {
      reset(defaultValues);
      if (defaultValues) {
        setDisplayValue(formatPriceUS(defaultValues?.disbursedAmount || 0));
      }
    }
  }, [isOpen, defaultValues, reset]);

  const [focusStates, setFocusStates] = useState({});
  const handleFocus = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field) => {
    setFocusStates((prev) => ({ ...prev, [field]: false }));
  };

  const submitHandler = (data) => {
    onSubmit(data);
  };

  // Price
  const [displayValue, setDisplayValue] = useState(0);

  const onChangePrice = useCallback(
    (event) => {
      const { value } = event.target;
      const numericValue = value.replace(/[^0-9]/g, "");
      setDisplayValue(formatPriceUS(numericValue));
      setValue("disbursedAmount", Number(numericValue), {
        shouldValidate: true,
      });
    },
    [setValue, watch, formatPriceUS]
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        h={"425px"}
        w={"100%"}
        maxW={"625px"}
        overflowY={"auto"}
        sx={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
          "&::-moz-scrollbar": {
            width: "4px",
          },
          "&::-moz-scrollbar-thumb": {
            width: "4px",
            borderRadius: "50px",
            background: "var(--color-background)",
          },
        }}
      >
        <form onSubmit={handleSubmit(submitHandler)}>
          <Flex minH={"425px"} flexDirection={"column"}>
            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={"10px"}
              padding={"25px 24px"}
              borderBottom={"1px solid var(--bg-line-employee)"}
            >
              <Text
                color="var(--color-header-employee)"
                fontSize={"18px"}
                fontWeight={"600"}
              >
                Tạo thanh toán
              </Text>
              <Box cursor={"pointer"} onClick={onClose}>
                <Image src={CloseIconBlack} />
              </Box>
            </Flex>
            <Box flex={1} w={"545px"} m={"24px auto"}>
              <Flex
                justifyContent={"space-between"}
                alignItems={"flex-start"}
                gap={"27px"}
                mb={"16px"}
              >
                <InputControl
                  // type="number"
                  label="Số tiền thanh toán"
                  placeholder="Ví dụ: 195000000000 "
                  errors={errors.disbursedAmount}
                  onFocus={() => handleFocus("disbursedAmount")}
                  onBlur={() => handleBlur("disbursedAmount")}
                  onChange={onChangePrice}
                  value={displayValue}
                  state={focusStates["disbursedAmount"]}
                  register={register("disbursedAmount")}
                  mwidth={"100%"}
                  isRequired={true}
                />
              </Flex>
            </Box>
            <Flex p={"24px"} justifyContent={"flex-end"}>
              <Button
                type="submit"
                p={"13px 16px 13px 20px"}
                fontWeight={600}
                fontSize={"15px"}
                lineHeight={"18px"}
                color={"var(--color-main)"}
                bg={"var(--color-button)"}
                _hover={{
                  filter: "brightness(90%)",
                }}
              >
                Thanh toán
              </Button>
            </Flex>
          </Flex>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default AddBrokerDebtDisbursement;
